import {useFetchAndRender} from "./fetchAndRender";
import {WithAPI} from "../api/temperature";
import {Card} from "./generic/card";
import {ColumnProps, Row, Table} from "./generic/table";
import Icon from "@mdi/react";
import {mdiMagnify} from "@mdi/js";
import {useState} from "preact/hooks";
import {Button, ButtonList} from "./generic/button";
import {SensorSet} from "../api/set";

/**
 * @TODO
 * - Inline editing of sensor set
 */

export function SensorSetsTable(props: { sets: SensorSet[] }) {
    const [filter, setFilter] = useState<string>("");

    const filterSet = (set: SensorSet): boolean =>
        set.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0;

    return <Card title="Sensor sets">
        <Table columns={[
            {id: "name", title: "Name", filter: true, class: "text-left", colspan: 2, },
        ]} onFilter={(column: ColumnProps, value: string) => setFilter(value)}>{(props.sets)
            .filter((set: SensorSet) => filterSet(set))
            .map((set: SensorSet) => <Row cells={{
                "name": <>
                    <td><a href={set.url} class="link-invisible">{set.name}</a></td>
                    <td class="td-shrink"><ButtonList><Button as="a" href={set.url} className="btn"><Icon size="1em" path={mdiMagnify} /></Button></ButtonList></td>
                </>
            }} />)
        }</Table>
    </Card>;
}
